import React, { useEffect, useState } from "react";
import { LockSimple, Snowflake } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import SocialHub from "@/components/SocialHub";

export default function Hub() {
  const [sentiment, setSentiment] = useState(null);

  useEffect(() => {
    api.hubSentiment().then(setSentiment).catch(() => {});
  }, []);

  const top = (sentiment?.players || []).filter((p) => p.n > 0).slice(0, 8);

  return (
    <div className="space-y-4" data-testid="hub-page">
      <div className="flex items-end justify-between gap-4 flex-wrap">
        <div>
          <h2 className="heading text-2xl font-black">Social Hub</h2>
          <p className="text-[12px] text-zinc-400 mt-1 max-w-2xl leading-relaxed">
            One room per live slate, locked read-only at kickoff. News blends real beat-writer and
            team RSS with our own feeds — Vegas line moves, DK slate changes and designation
            changes — so every card can act on your pool.
            Lock / fade votes become a <span className="text-[#FFCC00]">first-party field signal</span>:
            they nudge ownership and leverage, never projections.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 xl:grid-cols-4 gap-4">
        <section className="xl:col-span-3 bg-[#0a0a0a] border border-zinc-800">
          <SocialHub />
        </section>

        <aside className="bg-[#0a0a0a] border border-zinc-800 p-3" data-testid="hub-sentiment">
          <div className="overline mb-2">Crowd sentiment</div>
          <div className="mono text-[9px] text-zinc-500 leading-relaxed mb-3">
            Our members are a measurable slice of the field. At{" "}
            {sentiment?.min_votes_for_leverage ?? 10}+ votes a player's lock share nudges our field
            ownership estimate by up to ±15%.
          </div>
          {top.length === 0 && (
            <div className="mono text-[10px] text-zinc-600" data-testid="hub-sentiment-empty">
              No votes yet — react to a news card to start the signal.
            </div>
          )}
          <div className="space-y-2">
            {top.map((p) => (
              <div key={p.player_key} className="border border-zinc-900 px-2 py-1.5" data-testid={`sentiment-${p.player_key}`}>
                <div className="flex items-baseline justify-between gap-2">
                  <span className="text-[12px] text-zinc-200 font-bold capitalize truncate">{p.player_key}</span>
                  <span className="mono text-[9px] text-zinc-600">{p.n} votes</span>
                </div>
                <div className="flex items-center gap-3 mt-1">
                  <span className="mono text-[10px] text-[#39FF14] inline-flex items-center gap-1">
                    <LockSimple size={10} weight="fill" /> {p.lock}
                  </span>
                  <span className="mono text-[10px] text-[#4DA6FF] inline-flex items-center gap-1">
                    <Snowflake size={10} weight="fill" /> {p.fade}
                  </span>
                  {p.lock_pct != null && (
                    <span className="mono text-[10px] text-zinc-400 ml-auto">{p.lock_pct}% lock</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </aside>
      </div>
    </div>
  );
}
